'use strict';
module.exports = require('./Dialog.vue');